<script setup lang="ts">
import logoLight from '/logo-light.svg'
import vendorLogo from '/VendorLogo.svg'
</script>

<template>
  <div class="login-page">
    <div class="brand-section"></div>
    <div class="brand">
      <img class="system-logo" :src="logoLight" alt="Logo" />
      <h1>System chmurowego monitoringu sprężarkowni</h1>
      <h1>Tworzymy nową jakość</h1>
    </div>
    <div class="footer">
      <img class="vendor-logo" :src="vendorLogo" alt="Logo" />
      <hr class="separator" />
      <div class="links">
        <div class="link-group">
          <a href="https://mikroel.pl" target="_blank">www.mikroel.pl</a>
          <a href="tel:[+48713521802]" target="_blank">tel. +48 71 352 18 02</a>
          <a href="mailto:mikroel@mikroel.pl" target="_blank">mikroel@mikroel.pl</a>
        </div>
        <div class="link-group">
          <a href="https://mikroel.pl/polityka-prywatnosci/" target="_blank">Polityka prywatności</a>
          <a href="https://www.mikroel.pl" target="_blank">Ustawienia cookie</a>
          <a href="https://mikroel.pl/polityka-prywatnosci/" target="_blank">Regulamin</a>
        </div>
      </div>
    </div>

    <div class="login-section">
      <div class="top-gradient"></div>
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-page {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    height: auto;
    min-height: 100%;
  }
}

.brand-section {
  grid-area: 1 / 1 / 3 / 2;
  @media (max-width: 1024px) {
    grid-area: 1 / 1 / 2 / 2;
  }
  background: #06115a;
  background: linear-gradient(30deg, var(--ullib-color-primary) 0%, var(--ullib-color-gradient-login) 0%, var(--ullib-color-primary) 36%);
}

.brand {
  grid-area: 1 / 1 / 2 / 2;
  padding-top: 200px;
  padding-left: 76px;
  padding-right: 76px;
  color: var(--ullib-color-contrast);
  h1 {
    margin-bottom: 2px;
  }
  @media (max-width: 1024px) {
    padding: 24px 16px;
    h1 {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 0px;
    }
  }
}

.system-logo {
  height: 130px;
  margin-bottom: 31px;
  @media (max-width: 1024px) {
    height: 40px;
    margin-bottom: 24px;
  }
}

.links {
  display: flex;
  flex-direction: row;
  column-gap: 120px;
  row-gap: 40px;
  flex-wrap: wrap;
}

.link-group {
  display: flex;
  flex-direction: column;
  gap: 8px;

  a {
    color: var(--ullib-color-contrast);
    text-decoration: none;
    line-height: 20px;
    transition: color 0.2s ease-in-out;

    &:hover {
      text-decoration: underline;
    }
  }
}

.footer {
  grid-area: 2 / 1 / 3 / 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: start;
  padding-left: 76px;
  padding-right: 76px;
  padding-bottom: 40px;
  @media (max-width: 1024px) {
    grid-area: 3 / 1 / 3 / 2;
    background: #06115a;
    background: linear-gradient(30deg, var(--ullib-color-primary) 0%, var(--ullib-color-gradient-login) 0%, var(--ullib-color-primary) 36%);
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 24px;
    padding-bottom: 40px;
  }
}

.vendor-logo {
  height: 62px;
  margin-bottom: 24px;
}

.separator {
  border: none;
  height: 1px;
  background-color: var(--ullib-color-accent-2);
  margin: 0;
  margin-bottom: 24px;
  width: 100%;
}

.login-section {
  grid-area: 1 / 2 / 3 / 3;
  flex-grow: 1;
  height: 100%;
  padding-left: 170px;
  padding-right: 170px;
  padding-top: 160px;
  padding-bottom: 160px;
  flex-shrink: 1;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 1024px) {
    grid-area: 2 / 1 / 3 / 2;
    background-color: var(--ullib-color-background);
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 24px;
    padding-bottom: 120px;
  }
}

.top-gradient {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 320px;
  background: transparent linear-gradient(180deg, #06115a 0%, #edeeff00 100%) 0% 0% no-repeat padding-box;
  opacity: 0.24;
  z-index: -1;
}
</style>
